// Jedno miejsce na zapytania do naszego API z krajem wersji serwisu.
//
// Backend (backend_api/kraj.py) wybiera schemat bazy po nagłówku X-VV-Country:
// bez nagłówka dostajemy dane polskie, więc wersja polska wysyła zapytania dokładnie
// tak jak dotąd. Moduły API przechodzą na apiFetch stopniowo; dopóki moduł woła
// zwykłe fetch(), w wersji krajowej pokazałby dane polskie.

import { KRAJ, jestPolska } from '../kraj';

// Funkcja planu Premium (FE-02, kontrakt w repo VV `zadania/2026-10_plany-free-premium.md`): backend odpowiada
// 402 z `{kod: 'premium', funkcja}`. Ogłaszamy to zdarzeniem w oknie, a okno „Przejdź na Premium”
// (components/plany/OknoPremium) je łapie. Odpowiedź idzie dalej bez zmian: moduł API czyta ją jak dotąd,
// bo treść czytamy z kopii (`clone`). Inne statusy (np. 401 z allauth przy rejestracji) nie są ruszane.
export const ZDARZENIE_PREMIUM = 'vv:wymaga-premium';

const oglosPremium = (res) => {
  if (!res || res.status !== 402 || typeof res.clone !== 'function') return res;
  res.clone().json()
    .then((dane) => {
      if (dane && dane.kod === 'premium') {
        window.dispatchEvent(new CustomEvent(ZDARZENIE_PREMIUM, { detail: { funkcja: dane.funkcja || null } }));
      }
    })
    .catch(() => {});
  return res;
};

export const apiFetch = (url, options = {}) => {
  const zadanie = jestPolska
    ? fetch(url, options)
    : fetch(url, {
      ...options,
      headers: { ...(options.headers || {}), 'X-VV-Country': KRAJ.kod },
    });
  // Atrapy fetch w testach potrafią zwrócić coś, co nie jest obietnicą.
  return zadanie && typeof zadanie.then === 'function' ? zadanie.then(oglosPremium) : zadanie;
};

export default apiFetch;
